import './App.css';
import NoAuthRoutes from './routes/NoAuthRoutes';

function App() {
  return (
    <div className="App pb-5">
      <NoAuthRoutes />
    </div>
  );
}

export default App;
